export default __webpack_public_path__ + "static/media/color-swatch-icon.77e36a00.svg";